`use strict`;

class Contact {
  selectors = {
    form: `#contact, #contact-message-form, #airbnb-message-form, #airbnb-quote-form`,
  };

  constructor() {
    this.submitForm();
  }

  submitForm() {
    $(this.selectors.form).submit(function () {
      $(this).find("button[type='submit']").prop('disabled', true);
    });
  }
}

new Contact();
